import axiosClient from '@clients/axiosClient';
import { ChangeDueDateInputProps } from '@components/accountStatements/ChangeStatementsDueDateModal';

type IGetStatementsDetails = {
    accountId: string;
    page?: number;
    perPage?: number;
};

type GetDueDates = {
    programId: number;
    programDueDateId?: number;
};

type GetAvailableDueDates = {
    accountId: number;
};

export type PatchStatementDueDate = {
    accountId: number;
    dataToSubmit: ChangeDueDateInputProps;
};

export type StatementCalendarItem = {
    calendar_id: number;
    program_due_date_id: number;
    program_id: number;
    cycle_closing_date: string;
    due_date: string;
    real_due_date: string | null;
};

export type StatementItemType = {
    statement_id: number;
    cycle: number;
    previous_balance: number;
    debits: number;
    credits: number;
    current_balance: number;
    posted_date: string;
    minimum_payment: number;
    calendar: StatementCalendarItem;
};

export type Statement = {
    items: StatementItemType[];
    current_page: number;
    per_page: number;
    total_items: number;
    items_on_page: number;
    pages: number;
    is_last_page: boolean;
};

export type DueDate = {
    day: number;
    program_due_date_id: number;
    due_date: string;
    cycle_closing_date: string;
    best_transaction_day: number;
};

export type DueDateItem = {
    program_due_date_id: number;
    program_id: number;
    day: number;
    active: boolean;
    exists_account: boolean;
};

export type GetDueDatesResponse = {
    pagination: {
        current_page: number;
        per_page: number;
        total_items: number;
        items_on_page: number;
        pages: number;
        is_last_page: boolean;
        items: DueDateItem[];
    };
};

export type GetAvailableDueDatesResponse = {
    available_due_dates: DueDate[];
};

const statements = () => {
    const client = axiosClient();

    return {
        async getStatements({
            accountId,
            page = 1,
            perPage = 1,
        }: IGetStatementsDetails) {
            const { data } = await client.get<Statement>(
                `statements-v2/v3/accounts/${accountId}/statements`,
                {
                    params: { page, perPage, startFromCurrentCycle: true },
                },
            );
            return data;
        },

        async getProgramDueDates({ programId, programDueDateId }: GetDueDates) {
            const { data } = await client.get<GetDueDatesResponse>(
                `statements-v2/v1/programs/${programId}/due-dates`,
                {
                    params: { programDueDateId },
                },
            );
            return data;
        },

        async getAvailableDueDates({ accountId }: GetAvailableDueDates) {
            const { data } = await client.get<GetAvailableDueDatesResponse>(
                `statements/v1/accounts/${accountId}/available-due-dates`,
            );
            return data;
        },

        async patchStatementDueDate({
            accountId,
            dataToSubmit,
        }: PatchStatementDueDate) {
            const { data } = await client.put(
                `statements/v1/accounts/${accountId}/statements/due-date`,
                { ...dataToSubmit },
            );
            return data;
        },
    };
};

export default statements;
